import { authSlice } from "../features/auth/redux/slice";
import { accountSettingsSlice } from "../features/account_settings/redux/slice";
import { masterDataSlice } from "../features/master/redux/slice";
import { conversationsSlice } from "../features/conversations/redux/slice";
import { commonSlice } from "../features/common/redux/slice";
import { combineReducers } from "@reduxjs/toolkit";
import { sitterSlice } from "../features/sitter/redux/slice";
import { searchSlice } from "../features/search/redux/slice";

export const rootReducer = combineReducers({
  auth: authSlice.reducer,
  accountSettings: accountSettingsSlice.reducer,
  conversations: conversationsSlice.reducer,
  masterData: masterDataSlice.reducer,
  common: commonSlice.reducer,
  sitter: sitterSlice.reducer,
  search: searchSlice.reducer
});
